module.exports = __webpack_public_path__ + "img/round-arrow-right-hover.6f6f9ea1.svg";